import { render, staticRenderFns } from "./BlackjackTablesElement.vue?vue&type=template&id=4ee86b20&scoped=true"
import script from "./BlackjackTablesElement.vue?vue&type=script&lang=js"
export * from "./BlackjackTablesElement.vue?vue&type=script&lang=js"
import style0 from "./BlackjackTablesElement.vue?vue&type=style&index=0&id=4ee86b20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee86b20",
  null
  
)

export default component.exports